module.exports = __webpack_public_path__ + "static/media/search.0e3026cd.png";